import LogoImage from "../../assets/logo_xs.png";

export const Logo = () => {
  return <img style={{ width: 65, height: 40 }} src={LogoImage} alt="Logo" />;
};
